import { useEffect } from 'react';
import { click as clickAPI } from '../services/api';

/**
 * Custom Hook: usePageTracking
 * Tracks page visits automatically on mount.
 * Uses the same click tracking endpoint with page-level granularity.
 *
 * @param {string} page - Page identifier (e.g. 'home', 'candy', 'about')
 */
export function usePageTracking(page) {
  useEffect(() => {
    if (!page) return;

    clickAPI.track(page).catch(() => {
      // Silently fail — duplicate or network error is fine
    });
  }, [page]);
}
